const PERMISSION_ALIASES = {
  'emails.queue.view': ['emails.view'],
  'emails.queue.manage': ['emails.manage', 'emails.send'],
  'attendances.view': ['attendance.view', 'attendances.edit', 'attendance.edit', 'attendances.manage', 'attendance.manage'],
  'attendances.edit': ['attendance.edit', 'attendance.view', 'attendances.view', 'attendances.manage', 'attendance.manage'],
  'attendances.manage': ['attendance.manage', 'attendances.view', 'attendances.edit', 'attendance.view', 'attendance.edit'],
  'cycles.view': ['cycle.view'],
  'clients.fields': ['columns.view', 'columns.add', 'columns.edit'],
  'planification_review': ['planifications.review', 'planification_all'],
};

export const ATTENDANCE_PERMISSIONS = [
  'attendances.view',
  'attendances.edit',
  'attendances.manage',
  'attendance.view',
  'attendance.edit',
  'attendance.manage',
];

const addPermissionName = (set, entry) => {
  if (!entry) return;
  if (typeof entry === 'string') {
    set.add(entry);
    return;
  }
  if (typeof entry === 'object' && typeof entry.name === 'string') {
    set.add(entry.name);
  }
};

/** Merge permission names from API payload and nested user role assignments. */
export const collectPermissionNames = (user, apiPermissions) => {
  const names = new Set();

  if (Array.isArray(apiPermissions)) {
    apiPermissions.forEach((entry) => addPermissionName(names, entry));
  }

  if (Array.isArray(user?.permissions)) {
    user.permissions.forEach((entry) => addPermissionName(names, entry));
  }

  if (Array.isArray(user?.roles)) {
    user.roles.forEach((role) => {
      if (Array.isArray(role?.permissions)) {
        role.permissions.forEach((entry) => addPermissionName(names, entry));
      }
    });
  }

  return Array.from(names);
};

export const normalizeRoleNames = (roles) => {
  if (!Array.isArray(roles)) return [];
  return roles
    .map((role) => (typeof role === 'string' ? role : role?.name))
    .filter(Boolean);
};

export const permissionGranted = (userPermissions, required) => {
  if (!required) return true;
  if (!Array.isArray(userPermissions)) return false;
  if (userPermissions.includes(required)) return true;

  return (PERMISSION_ALIASES[required] ?? []).some((alias) => userPermissions.includes(alias));
};

export const anyPermissionGranted = (userPermissions, requiredList) =>
  requiredList.some((permission) => permissionGranted(userPermissions, permission));

export const hasAttendanceAccess = (userPermissions) => {
  if (!Array.isArray(userPermissions)) return false;
  if (anyPermissionGranted(userPermissions, ATTENDANCE_PERMISSIONS)) return true;
  return userPermissions.some(
    (permission) => typeof permission === 'string' && /attendances?\./i.test(permission)
  );
};
